module.exports = ".container {\r\n\ttop: 0px;\r\n\tleft: 0;\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\tbackground: rgba(254, 254, 254, 0.5);\r\n\tposition: absolute;\r\n\tz-index: 2;\r\n}\r\n\r\n.container table tr td {\r\n\tvertical-align: middle;\r\n}\r\n\r\n.container table {\r\n\twidth: 100%;\r\n\theight: 100%;\r\n}\r\n\r\ntd mat-spinner {\r\n\tmargin: 0 auto;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/mask/mask.component.css
// module id = ./src/app/shared/components/mask/mask.component.css
// module chunks = main